import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class CreateUpdateChannelUserEntity {
  user?: UserMiniEntity
  channels?: Array<ChannelMiniEntity> | null
}
